<script>
import HomepageTopText from '../components/HomepageTopText.vue'
import Tout from '@/components/Tout.vue'
import TravelAnim from '@/components/TravelAnim.vue'
import fontsReady from '@/utils/fontsReady'

export default {
  name: 'HomeView',
  components: {
    HomepageTopText,
    Tout,
    TravelAnim
  },
  data() {
    return {
      // is app loaded
      loaded: false,
      projectLinksLoaded: [],
    }
  },
  mounted() {
    fontsReady().then(() => {
      this.loaded = true;
      this.animateProjectLinks();
    });
  },
  methods: {
    animateProjectLinks() {
      const projectLinks = document.querySelectorAll('.project-link');
      projectLinks.forEach((link, index) => {
        setTimeout(() => {
          this.projectLinksLoaded.push(index);
        }, 400 + (index * 150)); // Start at 400ms, stagger by 150ms
      });
    },
  }
}
</script>

<template>
  <main :class="{ loaded: loaded }">
    <HomepageTopText />
    <RouterLink to="/chase-travel" class="project-link cover" :class="{ 'animate-in': projectLinksLoaded.includes(0) }">
      <figure>
        <div class="travel-anim-container">
          <TravelAnim />
        </div>
        <div class="caption">
          Lake Atitlán, Guatemala | Photo by Ramzi Dreessen
        </div>
        <figcaption>
          <h2 class="title">
            Case Study: Chase Travel
          </h2>
        </figcaption>
        <ul class="project-metadata">
          <li>
            <span><b>Role</b></span>
            <span>Product</span>
          </li>
          <li>
            <span><b>Tech</b></span>
            <span>My brain 🧠</span>
          </li>
          <li>
            <span><b>Date</b></span>
            <span>2025</span>
          </li>
        </ul>
      </figure>
    </RouterLink>
    <RouterLink to="/chase-travel-fixed" class="project-link cover"
      :class="{ 'animate-in': projectLinksLoaded.includes(1) }">
      <figure>
        <div class="img-bg chitravel-bg" v-view-transition-name="'chitravel-bg'"
          :style="{ backgroundImage: projectLinksLoaded.includes(1) ? 'url(' + require('@/assets/CT-laptop-mock.webp') + ')' : 'none' }">
        </div>
        <figcaption>
          <h2 class="title">
            Fixing Chase Travel’s Web App
          </h2>
        </figcaption>
        <ul class="project-metadata">
          <li>
            <span><b>Role</b></span>
            <span>Designer/Developer</span>
          </li>
          <li>
            <span><b>Tech</b></span>
            <span>Cursor, Claude, Vue.js, Typescript, Pinia</span>
          </li>
          <li>
            <span><b>Date</b></span>
            <span>2025</span>
          </li>
        </ul>
      </figure>
    </RouterLink>
    <RouterLink to="/high5games" class="project-link cover" :class="{ 'animate-in': projectLinksLoaded.includes(2) }">
      <figure>
        <div class="tout-container" ref="toutContainer">
          <Tout v-view-transition-name="'tout-animation'" />
        </div>
        <figcaption>
          <h2 class="title">
            High 5 Games Casino
          </h2>
        </figcaption>
        <ul class="project-metadata">
          <li>
            <span><b>Role</b></span>
            <span>Frontend Developer</span>
          </li>
          <li>
            <span><b>Tech</b></span>
            <span>React, CSS, Tailwind, Lottie, Firebase</span>
          </li>
          <li>
            <span><b>Dates</b></span>
            <span>2019-2022</span>
          </li>
        </ul>
      </figure>
    </RouterLink>
    <RouterLink to="/chicagomagazine" class="project-link cover"
      :class="{ 'animate-in': projectLinksLoaded.includes(3) }">
      <figure>
        <div class="video-composite">
          <div class="video-bg">
            <video src="../assets/vid-10.mov" autoplay loop muted playsinline />
          </div>
          <div class="video-bg">
            <video src="../assets/vid-14.mov" autoplay loop muted playsinline />
          </div>
          <div class="video-bg not-mobile">
            <video src="../assets/vid-4.mov" autoplay loop muted playsinline />
          </div>
          <div class="video-bg not-mobile">
            <video src="../assets/vid-3.mov" autoplay loop muted playsinline />
          </div>
          <div class="video-bg not-mobile">
            <video src="../assets/vid-6.mov" autoplay loop muted playsinline />
          </div>
          <div class="video-bg not-mobile">
            <video src="../assets/vid-8.mov" autoplay loop muted playsinline />
          </div>
        </div>
        <figcaption>
          <h2 class="title">
            <em>Chicago</em> editorial web design
          </h2>
        </figcaption>
        <ul class="project-metadata">
          <li>
            <span><b>Role</b></span>
            <span>Lead Developer and Site Administrator</span>
          </li>
          <li>
            <span><b>Tech</b></span>
            <span>CSS, Adobe Creative Suite, jQuery</span>
          </li>
          <li>
            <span><b>Dates</b></span>
            <span>2017-2019</span>
          </li>
        </ul>
      </figure>
    </RouterLink>
    <RouterLink to="/chicagomagazine-subscription" class="project-link cover"
      :class="{ 'animate-in': projectLinksLoaded.includes(4) }">
      <figure>
        <div class="chimag-subscription-bg" v-view-transition-name="'chimag-subscription-redesign'"
          :style="{ backgroundImage: 'url(' + require('@/assets/ipad-chimag-mock.jpg') + ')' }">
        </div>
        <figcaption>
          <h2 class="title">
            <em>Chicago</em> subscription page overhaul
          </h2>
        </figcaption>
        <ul class="project-metadata">
          <li>
            <span><b>Role</b></span>
            <span>Lead Frontend Developer</span>
          </li>
          <li>
            <span><b>Tech</b></span>
            <span>CSS, Adobe Creative Suite, jQuery</span>
          </li>
          <li>
            <span><b>Dates</b></span>
            <span>2017-2019</span>
          </li>
        </ul>
      </figure>
    </RouterLink>
    <RouterLink to="/suntimes" class="project-link cover" :class="{ 'animate-in': projectLinksLoaded.includes(5) }">
      <figure>
        <div class="suntimes-bg" v-view-transition-name="'cst-image'"
          :style="{ backgroundImage: 'url(' + require('@/assets/print-design/IMG_0008.jpg') + ')' }">
        </div>
        <figcaption>
          <h2 class="title">
            Chicago <em>Sun-Times</em> print design
          </h2>
        </figcaption>
        <ul class="project-metadata">
          <li>
            <span><b>Role</b></span>
            <span>Multimedia Producer/Designer</span>
          </li>
          <li>
            <span><b>Tech</b></span>
            <span>Adobe Creative Suite</span>
          </li>
          <li>
            <span><b>Dates</b></span>
            <span>2012-2016</span>
          </li>
        </ul>
      </figure>
    </RouterLink>
    <p :class="{ 'animate-in': projectLinksLoaded.includes(6) }" class="extra-projects project-link"><span>📸</span>
      Earlier in my career, I was a <b>photographer</b> as well, shooting portraits and events. You can see <RouterLink
        to="/photo">some of my favorite
        shots from over the years here</RouterLink>.
    </p>
  </main>
</template>

<style lang="scss" scoped>
main {
  overflow-x: hidden;
  // necesary otherwise elements on homepage overflow
}

figure {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  cursor: pointer;


  .video-composite {
    overflow: hidden;
  }

  .travel-anim-container {
    max-width: 1200px;
    overflow: hidden;
  }

  .chitravel-bg {
    width: 100% !important;
    max-width: 840px !important;
    left: unset !important;
    right: unset !important;
    margin-bottom: 10px !important;
    background-position: 48% 100% !important;
    background-size: cover !important;
    padding-bottom: 50% !important;

    @media (min-width: 840px) {
      padding-bottom: 550px !important;
    }
  }

  .travel-anim-container,
  .tout-container,
  .img-bg,
  .video-composite,
  .chimag-subscription-bg,
  .suntimes-bg {
    display: block;
    width: 100%;
    border-radius: 16px;
    border: 2px solid #eee;
    transition: border 0.3s ease;
  }

  .travel-anim-container {
    border: 2px solid transparent;
  }

  .tout-container {
    border-radius: 16px;
    max-width: 100%;
    width: 960px;
  }

  .chimag-subscription-bg {
    width: 800px;
    max-width: 100%;
    height: 0;
    padding-bottom: 64%;

    @media (min-width: 840px) {
      padding-bottom: 500px;
    }

    background-size: cover;
    background-position: center top;
    background-repeat: no-repeat;
    border-radius: 16px;

    @media (min-width: 840px) {
      background-size: cover;
    }
  }

  .suntimes-bg {
    width: 800px;
    max-width: 100%;
    height: 0;
    padding-bottom: 64%;

    @media (min-width: 840px) {
      padding-bottom: 500px;
    }

    background-size: 1350px;
    background-position: 54% 49%;
    background-repeat: no-repeat;
    border-radius: 16px;
  }

  figcaption {
    color: $textColor !important;
    text-decoration: none !important;
    display: block;
    font-size: 1.5rem;
    width: 100%;

    @media (min-width: 840px) {
      width: unset;
      display: flex;
      align-items: baseline;
      justify-content: space-between;
    }

    .title {
      margin-right: 16px;
      text-wrap: balance;
      margin-bottom: 0;

      @media (min-width: 840px) {
        margin-bottom: 1rem;
      }
    }
  }

  &:hover {

    .travel-anim-container,
    .tout-container,
    .img-bg,
    .video-composite,
    .chimag-subscription-bg,
    .suntimes-bg {
      border: 2px solid $redPunch;
    }
  }

  .project-metadata {
    width: 100%;
    padding: 1rem 1.5rem 0;
    margin-left: 0;

    @media (min-width: 760px) {
      display: flex;
      justify-content: center;
      max-width: unset;
      margin: 0 auto;
    }

    li {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      gap: 0.5rem;

      &:not(:first-of-type) {
        border-top: 1px solid #eee;
        padding-top: 0.5rem;
        padding-bottom: 0rem;
      }

      @media (min-width: 760px) {
        display: block;
        padding-left: 16px;
        padding-right: 16px;
        gap: unset;

        &:not(:first-of-type) {
          border-top: unset;
          padding-top: unset;
          padding-bottom: unset;
        }

        span {
          display: block;
          white-space: nowrap;
        }
      }

      span {
        @include breakout-font;
        text-align: right;
        text-wrap: balance;

        @media (min-width: 760px) {
          text-align: center;
          text-wrap: unset;
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.project-link {
  opacity: 0;
  transform: perspective(1000px) rotateX(-8deg) translateY(30px);
  transition: opacity 0.8s cubic-bezier(0.34, 1.56, 0.64, 1), transform 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);

  &.animate-in {
    opacity: 1;
    transform: perspective(1000px) rotateX(0deg) translateY(0);
  }

  &.extra-projects {
    max-width: 740px;
    padding: 48px 1rem;
    font-size: 1.2rem;

    @media (min-width: 760px) {
      text-align: center;
    }
  }
}
</style>